/* unplugin-vue-components disabled */import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { getUrlParam } from '@/utils/tool';
import Loading from '@/components/loading.vue';
import { activeIndex } from './index';
export default {
  __name: 'App',

  setup(__props) {
    const Tab1 = defineAsyncComponent(() => import('./components/tab1/index.vue'));
    const Tab2 = defineAsyncComponent(() => import('./components/tab2/index.vue'));
    onMounted(() => {
      if (getUrlParam('page') === 'share') {
        activeIndex.value = 2;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(activeIndex) === 1 ? (_openBlock(), _createBlock(_unref(Tab1), {
        key: 0
      })) : _createCommentVNode("", true), _unref(activeIndex) === 2 ? (_openBlock(), _createBlock(_unref(Tab2), {
        key: 1
      })) : _createCommentVNode("", true), _createVNode(Loading)], 64);
    };
  }

};